import { ReactNode } from 'react';

import { Flex, Pill, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const InReviewRequirementItem = ({ title }: { title: ReactNode }) => {
    return (
        <Flex
            padding="container"
            gap="section"
            align="center"
            justify="between"
        >
            <Text className="text-m font-med text-primary-10">{title}</Text>
            <Pill variant="london">
                <FormattedMessage
                    id="_.funding_requirements_v2.status.in_review"
                    defaultMessage="In review"
                />
            </Pill>
        </Flex>
    );
};
